import React, { useState, useEffect } from "react";
import { api } from "../../api/axios";
import { useAuth } from "../../hooks/auth";
import { UserRole } from "../../types/auth";
import SidebarItem from "components/SidebarItem/SidebarItem";
import analyticsIcon from "assets/analytics.png";
import dashboardIcon from "assets/dashboard.png";
import schoolManagementIcon from "assets/school.png";
import userManagementIcon from "assets/user-add.png";
import myProfileIcon from "assets/edit-profile.png";
import courseIcon from "assets/courses.png";
import logoutIcon from "assets/log-out.png";
import logoIcon from "assets/logo.png";

import styles from "./SideBar.module.css";

const menuConfig = {
    [UserRole.SUPER_ADMIN]: [
        { label: "Dashboard", path: "/", icon: dashboardIcon },
        { label: "School Management", path: "/school-management", icon: schoolManagementIcon },
        // { label: "User Management", path: "/user-management", icon: userManagementIcon },
        { label: "Subject", path: "/subject", icon: courseIcon },
        { label: "Analytics", path: "/analytics", icon: analyticsIcon },
        // { label: "My Profile", path: "/edit-profile", icon: myProfileIcon },
    ],
    [UserRole.SCHOOL_ADMIN]: [
        { label: "Dashboard", path: "/", icon: dashboardIcon },
        { label: "User Management", path: "/user-management", icon: userManagementIcon },
        { label: "Subject", path: "/subject", icon: courseIcon },
        { label: "Analytics", path: "/analytics", icon: analyticsIcon },
        { label: "School Information", path: "/school-information", icon: schoolManagementIcon },
        { label: "My Profile", path: "/edit-profile", icon: myProfileIcon },
    ],
    [UserRole.STUDENT]: [
        { label: "Dashboard", path: "/", icon: dashboardIcon },
        { label: "Subject", path: "/subject", icon: courseIcon },
        { label: "School Information", path: "/school-information", icon: schoolManagementIcon },
        { label: "My Profile", path: "/edit-profile", icon: myProfileIcon }
    ],
    [UserRole.TEACHER]: [
        { label: "Dashboard", path: "/", icon: dashboardIcon },
        { label: "Subject", path: "/subject", icon: courseIcon },
        { label: "School Information", path: "/school-information", icon: schoolManagementIcon },
        { label: "My Profile", path: "/edit-profile", icon: myProfileIcon }
    ]
};

const DEFAULT_AVATAR = "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y";

const SidebarLayout = () => {
    const { user, logout } = useAuth()!;
    const [profile, setProfile] = useState<{ fullName: string; profileUrl: string } | null>(null);

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const response = await api.get('/auth/me');
                const data = response.data.data;
                setProfile({
                    fullName: data.full_name || 'User',
                    profileUrl: data.profile_url || DEFAULT_AVATAR
                });
            } catch (error) {
                console.error('Error fetching sidebar profile:', error);
            }
        };

        if (user) {
            fetchProfile();
        }
    }, [user]);

    if (!user) return null;

    const currentMenu = menuConfig[user.role as keyof typeof menuConfig] || [];

    return (
        <aside className={styles.sidebarContainer}>
            {/* Header / Logo Area */}
            <div className={styles.header}>
                <div className={styles.logoContainer}>
                    <img src={logoIcon} alt="Logo" className={styles.mainLogo} />
                </div>
            </div>

            {/* Navigation Items */}
            <div className={styles.navContainer}>
                {currentMenu.map((item) => (
                    <SidebarItem
                        key={item.path}
                        label={item.label}
                        path={item.path}
                        iconSrc={item.icon}
                    />
                ))}
            </div>

            {/* Footer / Profile & Logout */}
            <div className={styles.footer}>
                <div className={styles.profileSection}>
                    <div className={styles.profileInfoWrapper}>
                        <div className={styles.avatarWrapper}>
                            <img
                                src={profile?.profileUrl || DEFAULT_AVATAR}
                                alt="Profile"
                                className={styles.avatar}
                            />
                        </div>
                        <div className={styles.userInfo}>
                            <div className={styles.userName}>{profile?.fullName || ''}</div>
                            <div className={styles.userRole}>{user.role.replace('-', ' ')}</div>
                        </div>
                    </div>
                    <button
                        onClick={logout}
                        className={styles.logoutButton}
                        title="Logout"
                    >
                        <img className={styles.logoutIcon} src={logoutIcon} alt="Logout" />
                    </button>
                </div>
            </div>
        </aside>
    );
};

export default SidebarLayout;
